import axios from '../axios/axios.js';

export default {
    namespaced: true,
    state: {
        clientList:'',
        userList:'',
        organisations:'',
        dateFrom:'',
        dateTo: '',
        rejectionComments : [
            {id:0, name:'Cut Dictation'},
            {id:1, name:'Dictation'},
            {id:2, name:'No Dictation'}, 
            {id:3, name:'Referral Letter'},
            {id:4, name:'Operation Note'}, 
            {id:5, name:'Procedure Note'}, 
            {id:6, name:'Cardiosurgical Summary'}, 
            {id:7, name:'Amending Previous Letter'},
            {id:8, name:'Invalid NHI Number'}, 
            {id:9, name:'Duplicate File of -------'}, 
            {id:10, name:'Cancelled Dictation'}, 
            {id:11, name:'Dictating for Different Service'}, 
            {id:12, name:'Dictating for Adult and Congenital Heart Disease Clinic'}, 
            {id:13, name:'Unknown Author'},
            {id:14, name:'Poor Audio Quality'}, 
            {id:15, name:'Dictating for Future Date'},
            {id:16, name:'Dictating for CIDG'}, 
            {id:17, name:"Endocrinology Clinic's Bone Density Report"}, 
            {id:18, name:'Dictating for NZ Heart and Lung Transplant Clinic'}, 
            {id:19, name:'Colorectal MDM'}, 
            {id:20, name:'Dictating for other DHBs'}, 
            {id:21, name:'Maternity Diabetes Clinic'}, 
            {id:22, name:'Standard Letter for DAFNE Course'}, 
            {id:23, name:'Bowel Screening letter'}, 
            {id:24, name:'Author Not Found in Soprano'},
            {id:25, name:'Withdrawn'},
        ],
        isBESR:false,
        selectedDepartments:[],
        selectedAuthor:'',
        sortKey:'',
        sort:'',
        selectedUploader:'',
        status:'',
        paginate:10,
        priority:'',
        uploaderFilter:''
    },
    getters: {
        clientList: state => state.clientList,
        userList: state => state.userList,
        organisations: state => state.organisations,
        rejectionComments: state => state.rejectionComments,
        dateFrom: state => state.dateFrom,
        dateTo: state => state.dateTo,
        isBESR:state => state.isBESR,
        selectedDepartments: state => state.selectedDepartments,
        selectedAuthor: state => state.selectedAuthor,
        sortKey: state => state.sortKey,
        sort: state => state.sort,
        selectedUploader: state => state.selectedUploader,
        status: state => state.status,
        paginate: state => state.paginate,
        priority: state => state.priority,
    },
    actions: {
        async fetchClients({commit}) {
                await axios.get(`/api/clients`, {
                    params: {  status : 'active' },
                    headers : { 'Authorization' : `Bearer ${localStorage.getItem('token')}`}
                })
                .then( response => {
                    commit('setClients', response.data.data.data)
                })
        },
        async fetchUsers({commit}) {
            await axios.get(`/api/users`, {
                headers : { 'Authorization' : `Bearer ${localStorage.getItem('token')}`} 
            }).then(response => {
                commit('setUsers', response.data.users.data)
            })
        },
        async fetchOrg({commit}) {
            await axios.get(`/api/organizations/`, {
                headers : { 'Authorization' : `Bearer ${localStorage.getItem('token')}`}  
            }).then(response => {
                commit('setOrgs', response.data.organizations)
            })
        },
        async setDateFrom({commit},value) {
            await commit('setDateFrom', value)
        },
        async setDateTo({commit},value) {
            await commit('setDateTo', value)
        },
        async setRejectionComments({commit},value) {
            await commit('setRejectionComments', value)
        },
        async setIsBESR({commit},value) {
            await commit('setDateTo', value)
        },
        async setSelectedDepartment({commit},value) {
            await commit('setSelectedDepartment', value)
        },
        async setRemovedDepartment({commit}, value) {
            await commit('setRemovedDepartment', value)
        },
        async resetSelectedDepartment({commit}) {
            await commit('resetSelectedDepartment')
        },
        async setSelectedAuthor({commit},value) {
            await commit('setSelectedAuthor', value)
        },
        async setSortKey({commit},value) {
            await commit('setSortKey', value)
        },
        async setSort({commit},value) {
            await commit('setSort', value)
        },
        async setSelectedUploader({commit},value) {
            await commit('setSelectedUploader', value)
        },
        async setStatus({commit},value) {
            await commit('setStatus', value)
        },
        async setPaginate({commit},value) {
            await commit('setPaginate', value)
        },
        async setPriority({commit},value) {
            await commit('setPriority', value)
        },
    },
    mutations: {
        setClients: (state, clients) => (state.clientList = clients),
        setUsers: (state, users) => (state.userList = users),
        setOrgs: (state, org) => (state.organisations = org),
        setDateFrom: (state, dateFrom) => (state.dateFrom = dateFrom),
        setDateTo: (state, dateTo) => (state.dateTo = dateTo),
        setRejectionComments: (state, comments) => (state.rejectionComments = comments),
        setIsBESR: (state, isBESR) => (state.isBESR = isBESR),
        setSelectedDepartment: (state, department) => {
            state.selectedDepartments.push({
                id:department.id,
                name: department.name
            })        
        },
        setRemovedDepartment: (state, index) => {
            state.selectedDepartments.splice(index, 1)
        },
        resetSelectedDepartment: (state) => {
            state.selectedDepartments = []
        },
        setSelectedAuthor: (state, author) => (state.selectedAuthor = author),
        setSortKey: (state, sortKey) => (state.sortKey = sortKey),
        setSort: (state, sort) => (state.sort = sort),
        setSelectedUploader: (state, uploader) => (state.selectedUploader = uploader),
        setStatus: (state, status) => (state.status = status),
        setPaginate: (state, paginate) => (state.paginate = paginate),
        setPriority: (state, priority) => (state.priority = priority),
    }
}
